import React from 'react';

const Icon = ({ width = '50', height = '51', fill = '#010101', ...other }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 50 51" fill="none" {...other}>
            <path
                clipRule="evenodd"
                d="M39.287 11.503c-9.25 0-13.33-3.945-13.364-3.978l-.92-.941-.93.94c-.038.044-4.034 3.98-13.36 3.98-.35 0-.711-.005-1.077-.02l-1.3-.043v15.745c0 4.68 1.68 11.51 16.211 16.736l.456.162.455-.162C39.99 38.697 41.67 31.867 41.67 27.186V11.44l-1.305.043c-.365.015-.726.02-1.077.02Z"
                stroke="black"
                strokeWidth="1.875"
                strokeLinecap="round"
                strokeLinejoin="round"
            />

            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M24.656 22.668h5.767a.822.822 0 0 1 .705 1.244l-8.247 13.56a.758.758 0 0 1-1.037.253.75.75 0 0 1-.35-.787l1.762-8.923h-5.768a.822.822 0 0 1-.705-1.244l8.248-13.574a.758.758 0 0 1 1.037-.255.75.75 0 0 1 .351.788l-1.763 8.938Z"
                fill={fill}
            />
        </svg>
    );
};
export default React.memo(Icon);
